import { render, staticRenderFns } from "./AddActivity.vue?vue&type=template&id=35713c3f&scoped=true&"
import script from "./AddActivity.vue?vue&type=script&lang=js&"
export * from "./AddActivity.vue?vue&type=script&lang=js&"
import style0 from "./AddActivity.vue?vue&type=style&index=0&id=35713c3f&lang=less&scoped=true&"
import style1 from "./AddActivity.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35713c3f",
  null
  
)

export default component.exports